import {
  CardActions,
  CardHeader,
  Button,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { styled } from "@mui/material";
import {
  CustomCard,
  CustomCardMedia,
  CustomZoomImage,
} from "./common-components";

// Note: this component is not used since we change the specs
// to taking picture for identity card instead of uploading

const InvisibleInput = styled("input")({
  display: "none",
});

export default function ImageCard(props) {
  const theme = useTheme();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const handleUploadImage = (event) => {
    let file = event.target.files[0];
    if (file === undefined) {
      return;
    }
    if (!file["type"].includes("image")) {
      props.handleAlert("File được upload không phải là file ảnh");
      return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = () => {
      props.setImageData(reader.result);
    };
  };

  if (mobileScreen) {
    return (
      <CustomCard>
        <CardHeader title={props.title} />
        {props.imageData && (
          <CustomCardMedia
            component="img"
            src={props.imageData}
            alt={props.imageData ? props.title : null}
          />
        )}

        <CardActions>
          <label htmlFor={props.title}>
            <InvisibleInput
              accept="image/*"
              id={props.title}
              type="file"
              onChange={handleUploadImage}
              disabled={props.disabled}
            />
            <Button
              variant="contained"
              component="span"
              disabled={props.disabled}
            >
              Chọn ảnh
            </Button>
          </label>
        </CardActions>
      </CustomCard>
    );
  } else {
    return (
      <CustomCard sx={{ display: "flex" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            flexShrink: 0,
            height: "auto",
            justifyContent: "space-between",
          }}
        >
          <CardHeader title={props.title} />
          <CardActions>
            <label htmlFor={props.title}>
              <InvisibleInput
                accept="image/*"
                id={props.title}
                type="file"
                onChange={handleUploadImage}
                disabled={props.disabled}
              />
              <Button
                variant="contained"
                component="span"
                disabled={props.disabled}
              >
                Chọn ảnh
              </Button>
            </label>
          </CardActions>
        </Box>
        {props.imageData ? (
          <CustomZoomImage
            src={props.imageData}
            zoomScale={1}
            zoomType="hover"
            fadeDuration={0}
            hideHint={true}
          />
        ) : (
          // Some place holder image in the future
          <div style={{ minHeight: "20vh" }}></div>
        )}
      </CustomCard>
    );
  }
}
